import React from 'react';
import SpinnerOverlay from "src/components/common/SpinnerOverlay";
import PDAHeader from "src/components/common/Header";
import usePDA1130_R01Store from "./usePDA1130_R01Store";
import { usePDAContainer } from "src/hooks/usePDAContainer";
import { usePDA1130_R01Content } from "./PDA1130_R01Content";

// 목록 화면
import PDA1130_R01Search from "./PDA1130_R01Search";
import PDA1130_R01Table from "./PDA1130_R01Table";

// 상세 화면
import PDA1130_R01DetailInfo from "./PDA1130_R01DetailInfo";
import PDA1130_R01DetailTable from "./PDA1130_R01DetailTable"; // DetailTable = LOT 목록

interface PDA1130_R01ContainerProps {
  menuNm: string;
  menuCd?: string;
  onBack?: () => void;
}

const PDA1130_R01Container = ({ 
  menuNm, 
  menuCd, 
  onBack 
}: PDA1130_R01ContainerProps) => {
  
  const { 
    loading, 
    reset,
    showList,
    shippingOrderList,
  } = usePDA1130_R01Store();

  const { handleMenuClick } = usePDAContainer(reset);
  const { 
    handleSearch, 
    handleRefetch,
    handleSelectOrder,
    handleBackToList 
  } = usePDA1130_R01Content();

  return (
    <div className="w-full h-screen flex flex-col bg-white fixed inset-0">
      <PDAHeader 
        menuNm={menuNm} 
        menuCd={menuCd} 
        onBack={showList ? onBack : handleBackToList} 
        onMenuClick={handleMenuClick} 
      />

      <div className="flex-1 overflow-hidden">
        {showList ? (
          // ========== 목록 화면 ==========
          <div className="h-full flex flex-col">
            {/* 상단: 검색 조건 */}
            <PDA1130_R01Search 
              onSearch={handleSearch} 
            />

            {/* 하단: 테이블 */}
            <div className="flex-1 overflow-hidden">
              <PDA1130_R01Table 
                shippingOrderList={shippingOrderList}
                onSelectOrder={handleSelectOrder}
              />
            </div>
          </div>
        ) : (
          // ========== 상세 화면 ==========
          <div className="h-full flex flex-col">
            {/* 상단: LOT 스캔 영역 */}
            <PDA1130_R01DetailInfo />

            {/* 하단: 출고 목록 테이블 (품목별 지시량/검수량/잔량) */}
            <div className="flex-1 overflow-hidden">
              <PDA1130_R01DetailTable />
            </div>
          </div>
        )}
      </div>

      {loading && <SpinnerOverlay text="처리 중..." />}
    </div>
  );
};

export default PDA1130_R01Container;
